import { NgxJsonLdModule } from '@ngx-lite/json-ld';
import { FeaturedComponent } from './components/featured/featured.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsComponent } from './components/tabs/tabs.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PublicWishlistComponent } from './components/public-wishlist/public-wishlist.component';
import { ShimmerComponent } from './components/shimmer/shimmer.component';
import { TagsGridComponent } from './components/tags-grid/tags-grid.component';
import { RouterModule } from '@angular/router';
import { ToggleComponent } from './components/toggle/toggle.component';
import { ChatNowComponent } from './components/chat-now/chat-now.component';
import { ControlErrorsDirective } from './validators/forms/control-errors.directive';
import { ControlErrorComponent } from './validators/forms/control-error/control-error.component';
import { ControlErrorContainerDirective } from './validators/forms/control-error-container.directive';
import { FormSubmitDirective } from './validators/forms/form-submit.directive';
import { ExpiryFormatDirective } from './validators/credit-cards/directives/expiry-format.directive';
import { CvcFormatDirective } from './validators/credit-cards/directives/cvc-format.directive';
import { CreditCardFormatDirective } from './validators/credit-cards/directives/credit-card-format.directive';
import { HsLangDirective, LangDirective, LangPipe } from './directives/lang.directive';
import { LangLinkDirective } from './directives/lang-link.directive';
import { SrcsetPipe } from './pipes/srcset.pipe';
import { SrcsetDirective } from './directives/srcset.directive';
import { TranslationsUpdaterComponent } from './components/translations-updater/translations-updater.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { RecentArticlesComponent } from './components/recent-articles/recent-articles.component';
import { BugmeComponent } from './components/bugme/bugme.component';
import { ArticleDetailComponent } from './components/article-detail/article-detail.component';
import { SafePipe } from './pipes/safe.pipe';
import { SpinnySpinComponent } from './components/spinny-spin/spinny-spin.component';
import { WaveModule } from 'src/app/wave/wave.module';
import { NgxSpinnerComponent } from './components/spinner/components/ngx-spinner/ngx-spinner.component';
import { LicensesListComponent } from './components/licenses-list/licenses-list.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SfxTableComponent } from './components/tracks-sfx/sfx-table/sfx-table.component';
import { TrackGridComponent } from './components/tracks-sfx/track-grid/track-grid.component';
import { TrackComponent } from './components/tracks-sfx/track/track.component';
import { SfxComponent } from './components/tracks-sfx/sfx/sfx.component';
import { ReceiptDetailsComponent } from './components/cart/receipt-details/receipt-details.component';
import { MixedModalComponent } from './components/cart/mixed-modal/mixed-modal.component';
import { PricingTableComponent } from './components/pricing-table/pricing-table.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { SliderModule } from '../slider/slider.module';


@NgModule({
  declarations: [
    TabsComponent,
    ShimmerComponent,
    TagsGridComponent,
    ToggleComponent,
    ChatNowComponent,
    ControlErrorsDirective,
    ControlErrorComponent,
    ControlErrorContainerDirective,
    FormSubmitDirective,
    CreditCardFormatDirective,
    ExpiryFormatDirective,
    CvcFormatDirective,
    HsLangDirective,
    LangDirective,
    LangLinkDirective,
    LangPipe,
    SrcsetPipe,
    SafePipe,
    SrcsetDirective,
    TranslationsUpdaterComponent,
    SpinnerComponent,
    RecentArticlesComponent,
    ArticleDetailComponent,
    FeaturedComponent,
    BugmeComponent,
    PublicWishlistComponent,
    NotFoundComponent,
    SpinnySpinComponent,
    NgxSpinnerComponent,
    LicensesListComponent,
    SfxTableComponent,
    TrackGridComponent,
    TrackComponent,
    SfxComponent,
    ReceiptDetailsComponent,
    MixedModalComponent,
    PricingTableComponent
  ],
  entryComponents: [
    ControlErrorComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgxJsonLdModule,
    TooltipModule,
    PopoverModule,
  ],
  exports: [
    TabsComponent,
    ShimmerComponent,
    TagsGridComponent,
    ToggleComponent,
    ChatNowComponent,
    ControlErrorsDirective,
    ControlErrorComponent,
    ControlErrorContainerDirective,
    FormSubmitDirective,
    CreditCardFormatDirective,
    ExpiryFormatDirective,
    CvcFormatDirective,
    HsLangDirective,
    LangDirective,
    LangLinkDirective,
    LangPipe,
    SrcsetPipe,
    SafePipe,
    SrcsetDirective,
    SpinnerComponent,
    RecentArticlesComponent,
    FeaturedComponent,
    BugmeComponent,
    ArticleDetailComponent,
    PublicWishlistComponent,
    NotFoundComponent,
    SpinnySpinComponent,
    LicensesListComponent,
    SfxTableComponent,
    TrackGridComponent,
    TrackComponent,
    SfxComponent,
    ReceiptDetailsComponent,
    MixedModalComponent,
    PricingTableComponent,
  ],
})
export class SharedModule {
}
